import { Phone, ShoppingBag } from "lucide-react";
import { TAVERN } from "../../data/tavern";

export default function MobileDock() {
  return (
    <div
      data-testid="mobile-dock"
      className="mobile-dock"
      role="navigation"
      aria-label="Γρήγορες ενέργειες"
    >
      <a
        href={TAVERN.efoodUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="dock-efood-btn"
        className="flex items-center justify-center gap-2 bg-[color:var(--pk-red)] px-4 py-4 text-sm font-bold uppercase tracking-wide text-white"
      >
        <ShoppingBag className="h-4 w-4" strokeWidth={2.5} />
        EFOOD
      </a>
      <a
        href={`tel:${TAVERN.phoneTel}`}
        data-testid="dock-phone-btn"
        className="flex items-center justify-center gap-2 bg-[color:var(--pk-green)] px-4 py-4 text-sm font-bold uppercase tracking-wide text-white"
      >
        <Phone className="h-4 w-4" strokeWidth={2.5} />
        ΚΛΗΣΗ
      </a>
    </div>
  );
}
